const COMMANDS = {
  ADD_ATTRIBUTE: 1,
  REMOVED_ATTRIBUTE: 2,
  MOVED_ATTRIBUTE: 3,
  CHANGED_OPERATOR: 5,
  GROUPED_ATTRIBUTES: 10,
  UNGROUPED_ATTRIBUTES: 11,
  CLEARED: 15,
  CREATED_COUNT: 20,
  REMOVED_COUNT: 21,
  CHANGED_DATE: 30
}

export {
  COMMANDS
}



// WEBPACK FOOTER //
// ./src/app/appLogic/targetDefinition/attributeActionConstants.js